import {
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import ArrowBack from '@material-ui/icons/ArrowBackIos'
import EventIcon from '@material-ui/icons/Event'

import styles from '../../../resources/theme/global'
import { readyLaundry } from '../HomeActions'

import BaseRelatoryPage from '../../../components/hooks/BaseRelatoryPage'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import ReadyItemsFilter from './ReadyItemsFilter'
import colors from '../../../assets/colors'

function ReadyItems(props) {
  const dispatch = useDispatch()
  const { classes } = props

  useEffect(() => {
    dispatch(readyLaundry())
  }, [])

  const items = useSelector(state => state.dashboard.readyItemsLaundry)

  const renderOsNumber = item => {
    return (
      <TableCell component={Link} to={`/laundry-os/${item.id}/details`}>
        {item.id}
      </TableCell>
    )
  }

  return (
    <>
      <BaseRelatoryPage
        title="Itens de lavanderia prontos para entrega"
        btnReturn
        btnReturnPath="/"
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <ReadyItemsFilter classes={classes} isLaundry={true} />
          </Grid>

          <Grid item xs={12}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCellHeader>Número da OS</StyledTableCellHeader>
                    <StyledTableCellHeader>Cliente</StyledTableCellHeader>
                    <StyledTableCellHeader align="center">
                      Itens na OS
                    </StyledTableCellHeader>
                    <StyledTableCellHeader align="center">
                      Itens prontos para entrega
                    </StyledTableCellHeader>
                    <StyledTableCellHeader align="center">
                      Itens Entregues
                    </StyledTableCellHeader>
                    <StyledTableCellHeader align="center">
                      Data da Coleta
                    </StyledTableCellHeader>
                    {/* <StyledTableCellHeader align="center">
                      Data de entrega
                    </StyledTableCellHeader> */}
                    <StyledTableCellHeader />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items?.map(item => (
                    <TableRow
                      key={item.id}
                      style={{
                        background:
                          item.total_items == item.delivering_items
                            ? colors.bgSucess
                            : 'inherit',
                      }}
                    >
                      <TableCell
                        component={Link}
                        to={`/partners-module/os/${item.id}`}
                      >
                        {item.id_laundry_client}
                      </TableCell>
                      <StyledTableCellBody>
                        {item.client_name}
                      </StyledTableCellBody>
                      <StyledTableCellBody align="center">
                        {item.total_items}
                      </StyledTableCellBody>
                      <StyledTableCellBody align="center">
                        {item.delivering_items}
                      </StyledTableCellBody>
                      <StyledTableCellBody align="center">
                        {item.finished_items}
                      </StyledTableCellBody>
                      <StyledTableCellBody align="center">
                        {item.collected_at}
                      </StyledTableCellBody>
                      {/* <StyledTableCellBody align="center">
                        {item.deadline_date}
                      </StyledTableCellBody> */}
                      <StyledTableCellBody>
                        <IconButton
                          aria-label="calendar"
                          color="primary"
                          component={Link}
                          to={`/calendar/${item.id}`}
                        >
                          <EventIcon />
                        </IconButton>
                      </StyledTableCellBody>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </BaseRelatoryPage>
    </>
  )
}

export default withStyles(styles)(ReadyItems)
